package app.nestbridge.feature.invitations.usecase

import app.nestbridge.feature.invitations.service.InvitationService
import me.tatarka.inject.annotations.Inject

@Inject
class AcceptInvitationWithVerificationUseCase(
    private val invitationService: InvitationService,
) {
    suspend operator fun invoke(invitationId: String, verificationCode: String): Result<Unit> =
        invitationService.accept(invitationId, verificationCode)
}
